import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import LexonTooltipComponent from '@/components/forms/fields/LexonTooltip/LexonTooltipComponent.vue'

// PROPS

export default /*#__PURE__*/_defineComponent({
  __name: 'LfHeaderTooltipComponent',
  props: {
  title: {
    type: String as PropType<string>,
    required: true
  }
},
  setup(__props) {

const props = __props;



return { __sfc: true,props, LexonTooltipComponent }
}

})